import { t } from "js/i18n";

const PROMOTION_CODE_PATTERN = /^[A-Za-z0-9_-]+$/;
const MAX_PROMOTION_CODE_LENGTH = 64;

export function normalizePromotionCode(rawPromotionCode?: string | null): string | undefined {
    if (typeof rawPromotionCode !== "string") {
        return undefined;
    }

    const normalizedPromotionCode = rawPromotionCode.trim();
    return normalizedPromotionCode === "" ? undefined : normalizedPromotionCode;
}

export function getPromotionCodeValidationError(promotionCode?: string): string | undefined {
    if (!promotionCode) {
        return t("Promotion code is required");
    }

    if (promotionCode.length > MAX_PROMOTION_CODE_LENGTH) {
        return t("Promotion code must be {{max}} characters or less", { max: MAX_PROMOTION_CODE_LENGTH });
    }

    if (!PROMOTION_CODE_PATTERN.test(promotionCode)) {
        return t("Promotion code contains invalid characters");
    }

    return undefined;
}

export function getPromotionCodeFromSearchParams(searchParams: URLSearchParams): string | undefined {
    return normalizePromotionCode(searchParams.get("coupon") ?? searchParams.get("promotionCode"));
}
